import React, { useState, useEffect } from "react";
import jsPDF from "jspdf";
import "jspdf-autotable";
import "bootstrap/dist/css/bootstrap.min.css";
import {
  collection,
  onSnapshot,
  query,
  where,
  orderBy,
  doc,
  updateDoc,
} from "firebase/firestore";
import { db } from "../firebaseConfig";
import "./ChamadasTable.css";
import Swal from "sweetalert2";

const ChamadasTable = () => {
  const [chamadas, setChamadas] = useState([]);
  const [statusFilter, setStatusFilter] = useState("");
  const [garcomFilter, setGarcomFilter] = useState("");
  const [tipoFilter, setTipoFilter] = useState("");
  const [setorFilter, setSetorFilter] = useState("");
  const [avaliacaoFilter, setAvaliacaoFilter] = useState("");
  const [dataInicial, setDataInicial] = useState(new Date().toISOString().split("T")[0]);
  const [dataFinal, setDataFinal] = useState(new Date().toISOString().split("T")[0]);
  const [linhasPorPagina, setLinhasPorPagina] = useState(10);
  const [paginaAtual, setPaginaAtual] = useState(1);
  const [garcons, setGarcons] = useState([]);
  const [ordem, setOrdem] = useState("data_desc");
  const [finalizandoId, setFinalizandoId] = useState(null);

  useEffect(() => {
    if (!dataInicial || !dataFinal) return;

    const q = query(
      collection(db, "chamadas"),
      where("data_hora", ">=", `${dataInicial} 00:00:00`),
      where("data_hora", "<=", `${dataFinal} 23:59:59`),
      orderBy("data_hora", "desc")
    );

    const unsubscribe = onSnapshot(q, (snapshot) => {
      const dados = snapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data()
      }));
      setChamadas(dados);
    });

    return () => unsubscribe();
  }, [dataInicial, dataFinal]);

  useEffect(() => {
    const unsubscribe = onSnapshot(collection(db, "garcons"), (snapshot) => {
      const garconsData = snapshot.docs.map((doc) => doc.data());
      setGarcons(garconsData);
    });

    return () => unsubscribe();
  }, []);

  const chamadasFiltradas = chamadas.filter((chamada) => {
    const dataChamada = chamada.data_hora?.split(" ")[0] || "";
    return (
      (!statusFilter || chamada.status === statusFilter) &&
      (!garcomFilter || chamada.garcom === garcomFilter) &&
      (!tipoFilter || chamada.tipo === tipoFilter) &&
      (!setorFilter || chamada.setor === setorFilter) &&
      (!avaliacaoFilter || chamada.avaliacao === avaliacaoFilter) &&
      (!dataInicial || dataChamada >= dataInicial) &&
      (!dataFinal || dataChamada <= dataFinal)
    );
  });

  const chamadasPaginadas = chamadasFiltradas.slice(
    (paginaAtual - 1) * linhasPorPagina,
    paginaAtual * linhasPorPagina
  );

  const exportarPDF = () => {
    const docPDF = new jsPDF();
    const dataAtual = new Date().toLocaleString();

    docPDF.setFontSize(18);
    docPDF.text("Relatório de Chamadas", 10, 10);
    docPDF.setFontSize(12);
    docPDF.text(`Exportado em: ${dataAtual}`, 10, 20);

    const tableData = chamadasFiltradas.map((chamada) => [
      chamada.mesa,
      chamada.pulseira || "Não informado",
      chamada.status,
      chamada.garcom || "N/A",
      chamada.tipo === "conta" ? "Fechamento de Conta" : "Chamada",
      chamada.setor,
      chamada.avaliacao || "Sem avaliação",
      chamada.data_hora ? new Date((chamada.data_hora || "").replace(" ", "T")).toLocaleString() : "Não informado",
    ]);

    docPDF.autoTable({
      head: [["Mesa", "Pulseira", "Status", "Garçom", "Tipo", "Setor", "Avaliação", "Data e Hora"]],
      body: tableData,
      startY: 30,
    });

    docPDF.save(`Relatorio_Chamadas_${new Date().toISOString().split("T")[0]}.pdf`);
  };

  const somarTempos = (tempo1, tempo2) => {
    const paraSegundos = (tempo) => {
      const [min = "0m", seg = "0s"] = (tempo || "").split(" ");
      const minutos = parseInt(min.replace("m", "")) || 0;
      const segundos = parseInt(seg.replace("s", "")) || 0;
      return minutos * 60 + segundos;
    };

    const totalSegundos = paraSegundos(tempo1) + paraSegundos(tempo2);
    const minutos = Math.floor(totalSegundos / 60);
    const segundos = totalSegundos % 60;
    return `${minutos}m ${segundos}s`;
  };

const corPorTempo = (tempoStr) => {
  if (typeof tempoStr !== "string" || !tempoStr.trim()) return "";

  const tempoParts = tempoStr.split(" ");
  const minutos =
    parseInt(tempoParts[0]?.replace(/\D/g, ""), 10) || 0;
  const segundos =
    parseInt(tempoParts[1]?.replace(/\D/g, ""), 10) || 0;

  const totalSegundos = minutos * 60 + segundos;

  // Até 1 minuto: Arretado
  if (totalSegundos <= 60) {
    return "bg-success";
  }

  // De 1min01s até 2min59s: Oxente
  if (totalSegundos < 180) {
    return "bg-warning text-dark";
  }

  // A partir de 3 minutos: Putz
  return "bg-danger";
};

  // Helpers para finalizar manualmente
  const formatarDuracao = (segundosTotais) => {
    const m = Math.max(0, Math.floor(segundosTotais / 60));
    const s = Math.max(0, Math.floor(segundosTotais % 60));
    return `${m}m ${s}s`;
  };

  const calcularTempoAtendimentoAteAgora = (inicioStr) => {
    if (!inicioStr) return "0m 0s";
    const inicio = new Date((inicioStr || "").replace(" ", "T"));
    const agora = new Date();
    const diffSeg = Math.max(0, (agora - inicio) / 1000);
    return formatarDuracao(diffSeg);
  };

  // Finalizar com SweetAlert2
  const handleFinalizar = async (chamada) => {
    if (finalizandoId) return;

    const { isConfirmed } = await Swal.fire({
      title: `Finalizar a mesa ${chamada.mesa}?`,
      text:
        chamada.status === "finalizado"
          ? "Esta chamada já está finalizada."
          : "Isso encerrará a chamada agora.",
      icon: chamada.status === "finalizado" ? "info" : "warning",
      showCancelButton: chamada.status !== "finalizado",
      confirmButtonText: chamada.status === "finalizado" ? "Ok" : "Sim, finalizar",
      cancelButtonText: "Cancelar",
      confirmButtonColor: "#198754",
      cancelButtonColor: "#6c757d",
    });

    if (!isConfirmed || chamada.status === "finalizado") return;

    try {
      setFinalizandoId(chamada.id);

      const inicioAtendimentoStr = chamada.aceite_hora || chamada.data_hora;
      const agoraStr = new Date().toISOString().slice(0, 19).replace("T", " ");

      const tempoAtendimentoCalculado =
        chamada.tempoAtendimento && chamada.tempoAtendimento.trim() !== ""
          ? chamada.tempoAtendimento
          : calcularTempoAtendimentoAteAgora(inicioAtendimentoStr);

      await updateDoc(doc(db, "chamadas", chamada.id), {
        status: "finalizado",
        finalizadoManualmente: true,
        finalizado_em: agoraStr,
        tempoAtendimento: tempoAtendimentoCalculado,
      });

      Swal.fire({
        title: "Finalizado!",
        text: "A chamada foi encerrada com sucesso.",
        icon: "success",
        confirmButtonColor: "#198754",
      });
    } catch (e) {
      console.error(e);
      Swal.fire({
        title: "Erro",
        text: "Não foi possível finalizar. Tente novamente.",
        icon: "error",
      });
    } finally {
      setFinalizandoId(null);
    }
  };

  return (
    <div className="container-fluid mb-4">
      {/* Título */}
      <h4 className="text-center mb-4">
        📋 Detalhes de Chamadas
      </h4>

      {/* Subtítulo */}
      <div className="text-center mb-3">
        <h5 className="text-muted d-flex justify-content-center align-items-center gap-2">
          <i className="fas fa-filter text-secondary"></i> Filtros
        </h5>
      </div>

      {/* Filtros */}
      <div className="row g-3 align-items-end mb-3">
        {/* Status */}
        <div className="col-12 col-md-3">
          <label htmlFor="status" className="form-label">Status</label>
          <select id="status" className="form-select" onChange={(e) => setStatusFilter(e.target.value)}>
            <option value="">Filtrar por Status</option>
            <option value="pendente">Pendente</option>
            <option value="em_andamento">Em Andamento</option>
            <option value="finalizado">Finalizado</option>
          </select>
        </div>

        {/* Garçom */}
        <div className="col-12 col-md-3">
          <label htmlFor="garcom" className="form-label">Garçom</label>
          <select id="garcom" className="form-select" onChange={(e) => setGarcomFilter(e.target.value)}>
            <option value="">Todos</option>
            {garcons.map((garcom, index) => (
              <option key={index} value={garcom.nome}>{garcom.nome}</option>
            ))}
          </select>
        </div>

        {/* Tipo */}
        <div className="col-12 col-md-3">
          <label htmlFor="tipo" className="form-label">Tipo</label>
          <select id="tipo" className="form-select" onChange={(e) => setTipoFilter(e.target.value)}>
            <option value="">Filtrar por Tipo</option>
            <option value="chamada">Chamada</option>
            <option value="conta">Fechamento de Conta</option>
          </select>
        </div>

        {/* Setor */}
        <div className="col-12 col-md-3">
          <label htmlFor="setor" className="form-label">Setor</label>
          <select id="setor" className="form-select" onChange={(e) => setSetorFilter(e.target.value)}>
            <option value="">Filtrar por Setor</option>
            {["Deck", "Salão", "PeNaAreia", "Piscina", "Lounge"].map((setor) => (
              <option key={setor} value={setor}>{setor}</option>
            ))}
          </select>
        </div>

        {/* Datas */}
        <div className="col-6 col-md-3">
          <label htmlFor="dataInicio" className="form-label">Data Início</label>
          <input type="date" id="dataInicio" value={dataInicial} onChange={(e) => setDataInicial(e.target.value)} className="form-control" />
        </div>

        <div className="col-6 col-md-3">
          <label htmlFor="dataFim" className="form-label">Data Fim</label>
          <input type="date" id="dataFim" value={dataFinal} onChange={(e) => setDataFinal(e.target.value)} className="form-control" />
        </div>

        {/* Linhas por página */}
        <div className="col-6 col-md-3">
          <label htmlFor="linhas" className="form-label">Linhas por Página</label>
          <select
            id="linhas"
            className="form-select"
            value={linhasPorPagina}
            onChange={(e) => {
              setLinhasPorPagina(Number(e.target.value));
              setPaginaAtual(1);
            }}
          >
            <option value="10">10 Linhas</option>
            <option value="50">50 Linhas</option>
            <option value="100">100 Linhas</option>
            <option value={chamadasFiltradas.length}>Todas</option>
          </select>
        </div>

        {/* Ordenação */}
        <div className="col-6 col-md-3">
          <label htmlFor="ordem" className="form-label">Ordenar por</label>
          <select
            id="ordem"
            className="form-select"
            value={ordem}
            onChange={(e) => setOrdem(e.target.value)}
          >
            <option value="data_desc">Data (Mais recentes)</option>
            <option value="data_asc">Data (Mais antigos)</option>
            <option value="tempoEspera_asc">Tempo de Espera (Rápido → Lento)</option>
            <option value="tempoEspera_desc">Tempo de Espera (Lento → Rápido)</option>
            <option value="tempoTotal_asc">Tempo Total (Menor → Maior)</option>
            <option value="tempoTotal_desc">Tempo Total (Maior → Menor)</option>
          </select>
        </div>
      </div>

      {/* Ações e legenda */}
      <div className="d-flex justify-content-between flex-wrap align-items-center mb-3 gap-3">
       <div className="d-flex align-items-center gap-2 flex-wrap">
  <strong>Legenda: Tempo de Espera</strong>

  <span className="badge bg-success">
    Até 1 min (Arretado)
  </span>

  <span className="badge bg-warning text-dark">
    1min 01s a 2min 59s (Oxente)
  </span>

  <span className="badge bg-danger">
    A partir de 3 min (Putz)
  </span>
</div>
        <button onClick={exportarPDF} className="btn btn-primary">
          <i className="fas fa-file-pdf me-2"></i> Exportar PDF
        </button>
      </div>

      {/* Tabela */}
      <div className="table-responsive" style={{ maxHeight: "400px" }}>
        <table className="table table-striped table-hover align-middle">
          <thead className="table-dark" style={{ position: "sticky", top: 0, zIndex: 2 }}>
            <tr>
              <th>Mesa</th>
              <th>Pulseira</th>
              <th>Status</th>
              <th>Garçom</th>
              <th>Tipo</th>
              <th>Setor</th>
              <th>Avaliação</th>
              <th title="Tempo entre o chamado e o aceite">Tempo de Espera</th>
              <th title="Tempo entre o aceite e a finalização">Tempo em Atendimento</th>
              <th title="Tempo total entre chamado e finalização">Tempo Total</th>
              <th>Data e Hora</th>
              <th>Ações</th>
            </tr>
          </thead>
          <tbody>
            {chamadasFiltradas
              .sort((a, b) => {
                const parseSegundos = (tempoStr = "") => {
                  const [min = 0, seg = 0] = tempoStr
                    .split(" ")
                    .map((v) => parseInt(v.replace(/\D/g, "")) || 0);
                  return min * 60 + seg;
                };

                if (ordem === "data_desc") return new Date((b.data_hora || "").replace(" ", "T")) - new Date((a.data_hora || "").replace(" ", "T"));
                if (ordem === "data_asc") return new Date((a.data_hora || "").replace(" ", "T")) - new Date((b.data_hora || "").replace(" ", "T"));
                if (ordem === "tempoEspera_asc") return parseSegundos(a.tempoEspera) - parseSegundos(b.tempoEspera);
                if (ordem === "tempoEspera_desc") return parseSegundos(b.tempoEspera) - parseSegundos(a.tempoEspera);
                if (ordem === "tempoTotal_asc") return parseSegundos(somarTempos(a.tempoEspera, a.tempoAtendimento)) - parseSegundos(somarTempos(b.tempoEspera, b.tempoAtendimento));
                if (ordem === "tempoTotal_desc") return parseSegundos(somarTempos(b.tempoEspera, b.tempoAtendimento)) - parseSegundos(somarTempos(a.tempoEspera, a.tempoAtendimento));

                return 0;
              })
              .slice((paginaAtual - 1) * linhasPorPagina, paginaAtual * linhasPorPagina)
              .map((chamada) => (
                <tr key={chamada.id}>
                  <td>{chamada.mesa}</td>
                  <td>{chamada.pulseira || "Não informado"}</td>
                  <td>
                    {chamada.status === "pendente"
                      ? "Pendente"
                      : chamada.status === "em_andamento"
                      ? "Em Andamento"
                      : "Finalizado"}
                  </td>
                  <td>{chamada.garcom || "N/A"}</td>
                  <td>{chamada.tipo === "conta" ? "Fechamento de Conta" : "Chamada"}</td>
                  <td>{chamada.setor}</td>
                  <td>{chamada.avaliacao || "Sem avaliação"}</td>

                  {/* Tempo de Espera com cor */}
                  <td>
                    {chamada.tempoEspera ? (
                      <span className={`badge ${corPorTempo(chamada.tempoEspera)}`}>
                        {chamada.tempoEspera}
                      </span>
                    ) : (
                      "—"
                    )}
                  </td>

                  {/* Tempo em Atendimento */}
                  <td>{chamada.tempoAtendimento || "—"}</td>

                  {/* Tempo Total */}
                  <td>
                    {chamada.tempoEspera && chamada.tempoAtendimento
                      ? somarTempos(chamada.tempoEspera, chamada.tempoAtendimento)
                      : "—"}
                  </td>

                  {/* Data e Hora */}
                  <td>
                    {chamada.data_hora
                      ? new Date((chamada.data_hora || "").replace(" ", "T")).toLocaleString()
                      : "Não informado"}
                  </td>

                  {/* Ações */}
                  <td style={{ minWidth: 150 }}>
                    {chamada.status !== "finalizado" ? (
                      <button
                        className="btn btn-sm btn-success"
                        onClick={() => handleFinalizar(chamada)}
                        disabled={finalizandoId === chamada.id}
                        title="Finalizar agora"
                      >
                        {finalizandoId === chamada.id ? (
                          <>
                            <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                            Finalizando...
                          </>
                        ) : (
                          <>
                            <i className="fas fa-check me-2"></i>
                            Finalizar agora
                          </>
                        )}
                      </button>
                    ) : (
                      <span className="badge bg-secondary">—</span>
                    )}
                  </td>
                </tr>
              ))}
          </tbody>
        </table>
      </div>

      {/* Paginação */}
      <div className="d-flex flex-wrap justify-content-center gap-2 mt-4">
        <button
          className="btn btn-outline-secondary"
          onClick={() => setPaginaAtual((prev) => Math.max(prev - 1, 1))}
          disabled={paginaAtual === 1}
        >
          ⬅️ Anterior
        </button>

        {Array.from({ length: Math.ceil(chamadasFiltradas.length / linhasPorPagina) }, (_, i) => i + 1)
          .filter((page) =>
            page === 1 ||
            page === Math.ceil(chamadasFiltradas.length / linhasPorPagina) ||
            Math.abs(page - paginaAtual) <= 2
          )
          .map((page, index, arr) => (
            <React.Fragment key={page}>
              {index > 0 && page - arr[index - 1] > 1 && <span className="px-2">...</span>}
              <button
                className={`btn ${paginaAtual === page ? "btn-primary" : "btn-outline-secondary"}`}
                onClick={() => setPaginaAtual(page)}
              >
                {page}
              </button>
            </React.Fragment>
          ))}

        <button
          className="btn btn-outline-secondary"
          onClick={() =>
            setPaginaAtual((prev) =>
              Math.min(prev + 1, Math.ceil(chamadasFiltradas.length / linhasPorPagina))
            )
          }
          disabled={paginaAtual >= Math.ceil(chamadasFiltradas.length / linhasPorPagina)}
        >
          Próxima ➡️
        </button>
      </div>
    </div>
  );
};

export default ChamadasTable;